import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

export const toTitleCase = (str: string): string => {
  return startCase(toLower(str));
};
